import React from 'react'

export function WrapBannerImageWithHref({ href = '', src, target = '_blank' } = {}) {
  return (
    <div className='wrap__sale__link'>
      {
        href && href.length > 0
          ? <a href={href} target={target}>
            <BannerImage src={src} />
          </a>
          : <BannerImage src={src} />
      }
    </div>
  )
}

function BannerImage({ src } = {}) {
  return (
    <div className='wrap__seritficat__img'>
      <img
        className='seritficat__img'
        src={src}
        alt='Картинка'
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/item/WrapBannerImageWithHref.jsx